/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'

interface Props {
  'aria-label'?: any
  badge?: any
  badgecount?: string
  changeRadio?: () => void
  className?: string
  formClassName?: string
  icon?: string
  id?: any
  info?: any
  inline?: any
  inputProps?: any
  label?: any
  name?: any
  props?: any
  style?: any
  type?: any
}
const InputLabel = (inputProps: any) => {
  return (
    <label
      className={inputProps?.className}
      htmlFor={inputProps?.labelProps?.htmlFor}
    >
      {inputProps?.label}{' '}
      {inputProps?.currency && <span className='currency'>$</span>}{' '}
      {inputProps?.isbadge && (
        <span className={inputProps?.badge}>{inputProps?.isbadge}</span>
      )}{' '}
      {inputProps?.mandatory && <span className='mandatory'>*</span>}{' '}
      {inputProps?.isinfoLabel && (
        <span
          className={inputProps?.isinfoClassName}
          data-tip={inputProps?.infoLabel}
        >
          <span className={inputProps?.isinfoIcon}></span>
        </span>
      )}{' '}
      {inputProps?.extras && (
        <span
          className={inputProps?.extrasClassName}
          onClick={inputProps?.onClick}
        >
          {inputProps?.extras}{' '}
        </span>
      )}
    </label>
  )
}

export default InputLabel
